import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

export interface BlockbrainCredentials {
  apiKey: string;
  apiUrl: string;
  botId: string;
}

export async function getBlockbrainCredentials(): Promise<BlockbrainCredentials> {
  try {
    const data = await authenticatedFetchJson<BlockbrainCredentials>("/api/blockbrain-credentials", {
      method: "GET",
    });

    return {
      apiKey: data.apiKey || "",
      apiUrl: data.apiUrl || "",
      botId: data.botId || "",
    };
  } catch (error) {
    console.error("Error fetching Blockbrain credentials:", error);
    return { apiKey: "", apiUrl: "", botId: "" };
  }
}
